import PropTypes from "prop-types"
import { useEffect, useState } from "react"

import ImageLoader from "areas/product/jewlr/image-loader"
import Image from "components/ui/image"
import { cn } from "styles/utils"

const ProductImagePreview = ({
  className,
  loaderClassName,
  setIsLoadingPreview,
  sizes,
  src,
  srcSet,
  isLoadingPreview,
  ...props
}) => {
  const [currentSrc, setCurrentSrc] = useState(src)
  const [currentSrcSet, setCurrentSrcSet] = useState(srcSet)

  useEffect(() => {
    const img = new window.Image()
    img.src = src
    if (sizes) img.sizes = sizes
    if (srcSet) img.srcset = srcSet

    let cancelled = false

    img.onload = () => {
      if (!cancelled) {
        setCurrentSrc(src)
        setCurrentSrcSet(srcSet)
        setIsLoadingPreview(false)
      }
    }

    img.onerror = () => {
      if (!cancelled) {
        setIsLoadingPreview(false)
      }
    }

    return () => {
      cancelled = true
      img.onload = null
      img.onerror = null
    }
  }, [src, srcSet, sizes, setIsLoadingPreview])

  return (
    <>
      {(currentSrc || currentSrcSet) && (
        <Image
          alt="Product preview"
          className={cn(
            "h-auto w-full max-w-full object-contain transition-opacity duration-300 ease-in-out",
            isLoadingPreview && "opacity-50",
            className
          )}
          {...(sizes ? { sizes } : { "data-sizes": "auto" })}
          src={currentSrc}
          srcSet={currentSrcSet}
          {...props}
        />
      )}
      {isLoadingPreview && <ImageLoader className={loaderClassName} />}
    </>
  )
}

ProductImagePreview.propTypes = {
  className: PropTypes.string,
  isLoadingPreview: PropTypes.bool,
  loaderClassName: PropTypes.string,
  setIsLoadingPreview: PropTypes.func,
  sizes: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.string,
}

export default ProductImagePreview
